import { AxiosError } from 'axios';
import { GET_CHECK_ACCESS_APPEAL_REGISTRATION } from '../../constants/apiUrls';
import { GET_APPEAL_ACCESS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetCheckAccessAppealRegistration = ({ onSuccess, onError }: Input = {}) => {
  const getCheckAccessAppealRegistration = async () => {
    const res = await axiosClient.get<void>(GET_CHECK_ACCESS_APPEAL_REGISTRATION);
    return res.data;
  };

  return useCustomQuery([GET_APPEAL_ACCESS_QUERY_KEY], getCheckAccessAppealRegistration, {
    onSuccess,
    onError,
  });
};
